/**
 * View-mode toggle (cards vs table) + Cart button with item badge.
 *
 * Extracted from ProductsPage.js. Pure JSX with
 * props for state + callbacks — no internal state.
 */
import React from 'react';
import { Button } from '../../../components/ui/button';
import { Package, Layers, ShoppingCart } from 'lucide-react';


export function ViewToggleAndCart({ viewMode, onSetViewMode, cartCount, onGoToCart }) {
  return (
    <>
      <div className="flex gap-1">
        <Button
          variant={viewMode === 'cards' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSetViewMode('cards')}
          className={`h-9 w-9 p-0 ${viewMode === 'cards' ? 'bg-[#556B2F]' : 'border-[#E2E6D9]'}`}
          data-testid="view-mode-cards"
        >
          <Package className="w-4 h-4" />
        </Button>
        <Button
          variant={viewMode === 'table' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onSetViewMode('table')}
          className={`h-9 w-9 p-0 ${viewMode === 'table' ? 'bg-[#556B2F]' : 'border-[#E2E6D9]'}`}
          data-testid="view-mode-table"
        >
          <Layers className="w-4 h-4" />
        </Button>
      </div>
      <Button
        onClick={onGoToCart}
        variant="outline"
        size="sm"
        className="border-[#556B2F] text-[#556B2F] relative h-9 text-xs sm:text-sm"
        data-testid="go-to-cart-from-products"
      >
        <ShoppingCart className="w-4 h-4 sm:mr-1" />
        <span className="hidden sm:inline">Cart</span>
        {cartCount > 0 && (
          <span
            className="absolute -top-1.5 -right-1.5 bg-[#DAA520] text-white text-[10px] w-4 h-4 sm:w-5 sm:h-5 rounded-full flex items-center justify-center font-bold"
            data-testid="products-cart-badge"
          >
            {cartCount}
          </span>
        )}
      </Button>
    </>
  );
}
